import { ifProp } from 'src/shared/styled-utils/ifProp';
import styled from 'styled-components';

interface RowProps {
  noGutters?: boolean;
}

/**
 * Component for minimally replacing bootstrap row classes
 * @param {RowProps} props
 */
export const Row = styled.div<RowProps>`
  margin: 0 ${ifProp('noGutters', '0', '-15px')};

  // clearfix
  :after {
    content: '.';
    display: block;
    clear: both;
    visibility: hidden;
    line-height: 0;
    height: 0;
  }
`;
